





































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Art, isSold, lowestPrice, sizesFor } from "@/models/Art";

@Component
export default class Thumbnail extends Vue {
  @Prop({ required: true }) readonly art!: Art;
  /* Where the showcase found this painting's display copy. */
  @Prop({ required: true }) readonly url!: string;
  /* Width divided by height, taken from the display copy by the showcase. */
  @Prop({ required: true }) readonly ratio!: number;

  /* Whether the painting is in and can be shown. */
  private hung = false;

  /*
    An image already in cache can finish before Vue has bound the load handler,
    and would then hang there invisible waiting for an event that has been and
    gone. On a second visit that is the entire wall.
  */
  mounted() {
    const image = this.$refs.image as HTMLImageElement | undefined;
    if (image?.complete && image.naturalWidth) this.hung = true;
  }

  @Watch("url")
  onUrlChange() {
    this.hung = false;
  }

  get priceIsNan() {
    return isNaN(parseInt(this.art.price?.toString() ?? "", 10));
  }

  /**
   * Originals aren't sold through the site any more, so they carry no price —
   * only a "Sold" mark when the piece has genuinely sold.
   */
  get tagSuffix() {
    if (!this.art.isReproduction) return isSold(this.art) ? "Sold" : "";

    if (this.art.soldDate || this.priceIsNan) return "Sold";

    const from = lowestPrice(this.art);
    if (!from) return "";

    return sizesFor(this.art).length > 1 ? `from $${from}` : `$${from}`;
  }

  get captionNote() {
    return this.tagSuffix;
  }
}
